import { Component, inject, input, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';
import { DashboardItem } from '../../../api/app-types/dashboard.app';

@Component({
	selector: 'lvr-specialist-card',
	imports: [TranslocoPipe, MatCardModule],
	templateUrl: './specialist-card.html',
	styleUrl: './specialist-card.scss',
})
export class SpecialistCard {
	private readonly router = inject(Router);
	public readonly user = input.required<DashboardItem>();
	public readonly isNavigating = signal(false);

	public async onCardSelected(): Promise<void> {
		if (this.isNavigating()) return;

		const userId = this.user().objectId ?? String(this.user().id);

		this.isNavigating.set(true);
		try {
			await this.router.navigate(['/desk/user', userId]);
		} finally {
			this.isNavigating.set(false);
		}
	}
}
